import React, { useState, useEffect, useReducer } from "react";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  SwipeableDrawer,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Switch,
  Backdrop,
  CircularProgress,
  DialogContent,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import { toast } from "react-toastify";
import ViewIcon from "@material-ui/icons/Visibility";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useNotification } from "../../../hooks/useNotification.js";
import { HiUsers } from "react-icons/hi2";
import { useHistory } from "react-router-dom";
import { IoPeople } from "react-icons/io5";
import { IoIosShareAlt } from "react-icons/io";
import employee from "../../../images/sidebar_icon/EmployeeIcon.png";

export default function InternalJobposting() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const history = useHistory();
  const [count, setCount] = useState(0);

  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [internalJob, setInternalJob] = useState({});
  const [jobpostingData, setJobpostingData] = useState([]);
  const [jobPostingView, setJobpostingView] = useState({
    id: "",
    name: "",
    createdAt: "",
    isActive: "",
  });
  const [confimationOpen, setConfimationOpen] = useState(false);
  const [requirementId, setRequirementId] = useState("");
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);

  const HeaderElements = () => <>Total : {count}</>;

  const handleConfirmationModalOpen = (id) => {
    setRequirementId(id);
    setConfimationOpen(true);
  };

  const handleConfirmationModalClose = () => {
    setConfimationOpen(false);
    setRequirementId("");
  };

  useEffect(() => {
    fetchData();
  }, [reducerValue, token]);
  const fetchData = async () => {
    setLoader(true);

    axios({
      method: "get",
      // url: `${process.env.REACT_APP_SERVER}employee/viewIntrestedCandidates?requirementId={}page=${currentPage}`,
      url: `${process.env.REACT_APP_SERVER}employee/getInternalRequirements?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);

        setJobpostingData(response.data.data);
        console.log(response.data.data);
        setCount(response.data.count);
      }
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage + 1);
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/getInternalRequirements?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setJobpostingData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const handleSayInterest = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}employee/showInterstToRequirement`,
        data: {
          requirementId: requirementId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);
          fetchData();
        } else {
          handleNotificationCall("error", response.data.message);
        }
        setLoader(false);
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const ViewJobposting = async (req_id) => {
    setLoader(true);
    try {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}employee/getOneInternalRequirement`,
        data: {
          id: req_id,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.data.status === true) {
        const internalData = response.data.data;
        setInternalJob(internalData); // Update state
        console.log(internalData); // Correctly logs the new data
        toggleDrawer("right", true)();
      } else {
        console.error("API returned false status:", response.data.message);
      }
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoader(false); // Stop loader
    }
  };

  const list = (anchor) => (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        <Card className={classes.root}>
          <CardHeader>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.drawerHeader}
            >
              <Typography variant="subtitle1"> View Requirement</Typography>

              <Grid className={classes.drawerClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  size="14px"
                  onClick={toggleDrawer(anchor, false)}
                />
              </Grid>
            </Grid>
          </CardHeader>

          <CardContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Name:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementName +
                  " (" +
                  internalJob?.uniqueId +
                  ")"}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Experience:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {internalJob?.experience}
                </Grid>
                {/* {jobPostingView.isActive === true ? (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.green + " " + classes.noPointer}
                    >
                      ACTIVE
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.red + " " + classes.noPointer}
                    >
                      INACTIVE
                    </Button>
                  </>
                )} */}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Skills:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.skills}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Location:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.jobLocation}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Mode of work:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.modeOfWork}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Special hiring:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.specialHiring}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>JD:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementJd}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Gist:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div
                  dangerouslySetInnerHTML={{ __html: internalJob?.gist }}
                ></div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Posted Date:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {moment(internalJob?.createdAt).format("DD-MM-YYYY")}
              </Grid>
            </Grid>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
                width={100}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </CardContent>
        </Card>
      </List>
    </Box>
  );

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Internal Job Posting" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },

              {
                name: "Requirement Name",
              },
              {
                name: "Hiring Name",
              },
              {
                name: "Experience",
              },
              {
                name: "Skills",
              },
              {
                name: "Location",
              },
              {
                name: "Posted Date",
              },
              {
                name: "Action",
              },
            ]}
            data={jobpostingData.map((item, index) => {
              return [
                <>
                  {currentPage !== 0
                    ? 10 * currentPage - 10 + index + 1
                    : index + 1}
                </>,
                <>{item.requirementName + " (" + item.uniqueId + ")"}</>,

                <>
                  {item.client.handler.firstName +
                    " " +
                    item.client.handler.lastName}
                </>,

                item.experience,
                item.skills,
                item.jobLocation,
                moment(item.createdAt).format("DD-MM-YYYY"),
                <>
                  <Grid container className={classes.space}>
                    <Grid
                      item
                      xs
                      className={classes.toolAlign}
                      style={{ gap: "10px" }}
                    >
                      <Tooltip
                        title="View Candidates"
                        placement="bottom"
                        aria-label="view"
                      >
                        <span
                          onClick={() =>
                            history.push(
                              `/app/employee/internal-jobposting-referral-candidates?requirementId=${item.id}`,
                            )
                          }
                        >
                          <span
                            style={{
                              position: "relative",
                              paddingRight: "10px",
                              zIndex: 0,
                            }}
                          >
                            <IoPeople
                              style={{ width: "26px", height: "26px" }}
                              size={24}
                              color="#14377b"
                            />
                            <IoIosShareAlt
                              size={24}
                              color="#2bb036"
                              style={{
                                position: "absolute",
                                left: "14px",
                                top: "-11px",
                                zIndex: -1,
                              }}
                            />
                          </span>
                        </span>
                      </Tooltip>
                      <Tooltip
                        title="View Employees"
                        placement="bottom"
                        aria-label="view"
                      >
                        <span
                          onClick={() =>
                            history.push(
                              `/app/employee/internal-jobposting-candidates?requirementId=${item.id}`,
                            )
                          }
                        >
                          {/* <HiUsers size={24} color="#149e50" /> */}
                          <img
                            src={employee}
                            alt="employee"
                            width="100%"
                            style={{ width: "26px", height: "26px" }}
                          />
                        </span>
                      </Tooltip>
                      <Tooltip
                        title="View Job Requirement"
                        placement="bottom"
                        aria-label="view"
                      >
                        <ViewIcon
                          className={classes.toolIcon}
                          onClick={() => ViewJobposting(item.id)}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </>,
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{ paper: classes.drawer }}
        >
          {list("right")}
        </SwipeableDrawer>
      </Grid>

      <Dialog
        onClose={handleConfirmationModalClose}
        aria-labelledby="dialog-title"
        open={confimationOpen}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Confirmation
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleConfirmationModalClose}
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <Typography variant="subtitle2" style={{ textAlign: "left" }}>
            Do you wish to proceed with the application of this requirement?
          </Typography>
          <div className={classes.sendWhatsapp}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSayInterest}
            >
              Yes
            </Button>

            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={handleConfirmationModalClose}
            >
              No
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
